var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { apiCreateClientRfpShareDocumentAll } from '@/actions/ClientRfpShareDocumentActions';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { updateRfpCliFileFormAction } from '@/pages/rfp/client/RfpClientOneFileAllRoot/RfpClientOneFileAllRootReducer';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { formatUploadedFiles } from '@/utils/form/file';
import { clientRfpOneFileAllConfirmPath } from '@/utils/router/links';
/**
 * ファイル共有メッセージ：一括送付の更新制御（編集→確認ページ）
 */
export const useRfpClientOneFileAllSubmit = (args) => {
    const { dispatch, formDispatch, id, unmountRef } = args;
    const history = useNavigate();
    /**
     * フォーム送信：確認ページに遷移
     */
    const onSubmit = useCallback((formValues) => __awaiter(void 0, void 0, void 0, function* () {
        // バリデーションを実行
        yield wrapDispatch(dispatch, apiCreateClientRfpShareDocumentAll({
            json: {
                files: formatUploadedFiles(formValues.files),
                message: formValues.message,
                view_request_ids: formValues.viewRequestIds,
            },
            path: { id },
        }, { isValidateOnly: true }));
        if (!unmountRef.current) {
            // バリデーションに問題なければ入力値をstateに反映
            formDispatch(updateRfpCliFileFormAction(formValues));
            // 確認ページに遷移
            history.push(clientRfpOneFileAllConfirmPath(id));
        }
    }), [dispatch, id, formDispatch, history, unmountRef]);
    return {
        onSubmit,
    };
};
